import { UCCOperParams } from '@lk/api'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../index.d'

export const uccOperChangeStatus = createAsyncThunk<any, Partial<UCCOperParams>, ThunkApi>(
  '[UCC_OPER] CHANGE_STATUS',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.ucc.oper('changestatus', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const uccOperComm = createAsyncThunk<any, Partial<UCCOperParams>, ThunkApi>(
  '[UCC_OPER] COMM',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.ucc.oper('comm', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const uccOperDebt = createAsyncThunk<any, Partial<UCCOperParams>, ThunkApi>(
  '[UCC_OPER] DEBT',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.ucc.oper('debt', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const uccOperPay = createAsyncThunk<any, Partial<UCCOperParams>, ThunkApi>(
  '[UCC_OPER] PAY',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.ucc.oper('pay', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const uccOperSend = createAsyncThunk<any, Partial<UCCOperParams>, ThunkApi>(
  '[UCC_OPER] SEND',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.ucc.oper('send', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)
